import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useAtom } from 'jotai';
import { useEffect } from 'react';

import useHandleError from '@/hooks/useHandleError';
import type { EventsPerDayDTO } from '@/pages/Dashboard/Dashboard.types';

import { selectedDeviceDetailsAtom } from '../Devices.store';
import { deviceEventsPerDayAtom } from './DeviceTrendChart.store';

export const getDeviceType = (deviceTypeId?: number): string => {
  switch (deviceTypeId) {
    case 2:
      return 'log';
    case 3:
      return 'network';
    default:
      return '';
  }
};

export const getDeviceTypeLabel = (deviceTypeId?: number): string => {
  switch (deviceTypeId) {
    case 2:
      return 'Logs';
    case 3:
      return 'Events';
    default:
      return '';
  }
};
export const useFetchDeviceEventsPerDay = () => {
  const [selectedDeviceDetail] = useAtom(selectedDeviceDetailsAtom);
  const [, setDeviceEvents] = useAtom(deviceEventsPerDayAtom);
  const handleError = useHandleError();
  const { data, isSuccess, isError, error, isFetching } = useQuery<
    EventsPerDayDTO[],
    AxiosError
  >({
    queryKey: [
      `devices/${selectedDeviceDetail?.host_name}/${getDeviceType(selectedDeviceDetail?.device_type?.id)}/events/per_day`
    ],
    staleTime: 60 * 60 * 1000
  });

  useEffect(() => {
    if (isSuccess) {
      setDeviceEvents(data);
    }
    if (isError) {
      setDeviceEvents([]);
      handleError(error, 'Failure to fetch events data.');
    }
  }, [isSuccess, isError, data]);

  return {
    isFetching
  };
};
